import "../registration/client";

import I18n from "i18n-js";
import en from "../i18n/en.json";
import ptBR from "../i18n/pt-BR.json";

I18n.translations = { ...en, ...ptBR };
I18n.locale = document.documentElement.lang || "en";
window.I18n = I18n;

console.debug("DEBUG application.js - locale: ", I18n.locale);
console.debug("DEBUG application.js - defaultLocale: ", I18n.defaultLocale);
console.debug("DEBUG application.js - hello: ", I18n.t("hello"));

import moment from "moment";
moment.locale(I18n.locale);

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

import "../stylesheets/application.scss";